import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function SiteFooter() {
	return (
		<div class="row  overlayfooter">


			<div class="row">

				{/* <!-- About --> */}
				<div class="col-lg-4 footer_col">
					<div class="footer_about">
						<div class="logo_container" >
							<a href="#">
								<div class="logo_content d-flex- flex-row align-items-start justify-content-center">
									{/* <div class="logo_img"><img src="./images/spst-home-icon.png" alt="logo" className="footerimage"/></div> */}
									<div><h3 className="btm-heading" style={{ color: 'white', fontFamily: 'manjari',textAlign: 'left' }}>SREE TALI MAHAKSHETHRAM <br />(TALI DEVASWOM)</h3></div>
								</div>
							</a>
						</div>
						<div class="clear" style={{ paddingTop: '20%', fontFamily: 'manjari' }}>
							<p className="foottest">Tali temple is one of the oldest temples in Kozhikode. The temple was built by Swamy Thirumulapad. The founding and prosperity of Kozhikode city is closely linked with the sanctity of this ancient temple. </p>
						</div>
						{/* <div class="footer_social">
							<ul>
								<li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-pinterest" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
							</ul>
						</div> */}

					</div>
				</div>

				<div class="col-lg-4 footer_col">
					<div class="footer_links">
						<div class="footer_title">Quick menu</div>
						<ul className="footer_list">
							<li><Link to="/">Home</Link></li>
							<li><Link to="#">Online Booking</Link></li>
							<li><Link to="/History">History</Link></li>
							<li><Link to="/Administration">Administration</Link></li>
							<li><Link to="/Contact">Contact</Link></li>
						</ul>
					</div>
				</div>

				{/* <div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Useful Links</div>
						<ul class="footer_list">
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/">Online Booking</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75">Suvarna Darsan</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72">Kshethra Bhadratha Fund</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx">Gosala Donation</Link></li>
						</ul>
					</div>
				</div> */}

				<div class="col-lg-4 footer_col">
					<div class="footer_contact">
						<div class="footer_title" style={{ textAling: 'left', fontFamily: 'manjari' }}>Contact Us</div>
						<div class="footer_contact_info">
							<div class="footer_contact_item">
								<div class="footer_contact_title orange" style={{ fontFamily: 'manjari' }}>Address:</div>
								<div class="footer_contact_line">
									<p style={{ color: 'white', lineHeight: '15pt', fontFamily: 'manjari' }}>	SANGAMESH VARMA R <br />Executive Officer <br />SREE TALI MAHAKSHETHRAM 
(TALI DEVASWOM) <br /> Chalappuram(PO), Kozhikode, <br />
										Kerala 673002</p>
									{/* Ulsavamadam Building , North Nada<br />
									Sree Padmanabha Swamy Temple Fort,<br />
									Thiruvananthapuram – 695023.</p> */}
								</div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange" style={{ fontFamily: 'manjari' }}>Phone:</div>
								<div class="footer_contact_line white" style={{ fontFamily: 'manjari' }}>8289947686 </div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange" style={{ fontFamily: 'manjari' }}>Email:</div>
								<div class="footer_contact_line white" style={{ fontFamily: 'manjari' }}>talitempledt@gmail.com</div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyrightbottom">
					<div class="row">
						<div class="col-md-8">
							<div class="copyrighttext">
								<p class="foottest" style={{ lineHeight: '20px', fontFamily: 'manjari',marginBottom:'15px' }}>Copyright © 2026 SREE TALI MAHAKSHETHRAM (TALI DEVASWOM), All Rights Reserved.  <br />
									<Link to="/TermsAndConditions">Terms & Conditions </Link>, <Link to="/PrivacyPolicy">Privacy Policy</Link> Enabled by Kshethrasuvidham Temple Management Solutions.</p>
								<div className="footerlogo">
									<img src="./images/kshethrasuvidhamLogo.jpg" style={{ width: '70%' }} />
								</div>
							</div>
						</div>
						{/* <div class="col-md-4">
							<div className="footerlogo">
								<img src="./images/kshethrasuvidhamLogo.jpg" style={{ width: '50%' }} />
							</div>
						</div> */}
					</div>


				</div>
			</div>
		</div>
	);
}

export default SiteFooter;

